// ======================================================================
// File Name       : NoticeDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Modal, Col, Form } from 'react-bootstrap';

class EnterpriseDetail extends React.Component {
  render() {
    const { noticeInfo, showDialog, onClickDownload } = this.props;
    // #6337 START
    // #6555 START
    const MULTILANG_TYPE = 'multilang';
    const fileDownloadList = [];
    const fileDownloadListMultilang = [];

    if (noticeInfo.fileDownloadUrlList) {
      noticeInfo.fileDownloadUrlList.map((fileDownloadUrl, index) => {
        if (fileDownloadUrl.includes(MULTILANG_TYPE)) {
          fileDownloadListMultilang.push(fileDownloadUrl);
        } else {
          fileDownloadList.push(fileDownloadUrl);
        }
      });
    }

    const fileDownloadUrlListView = (
      <div>
        {fileDownloadList.length === 1 &&
        fileDownloadList.map((fileDownloadUrl, index) => (
          <Button
            variant="primary"
            className="btn-96"
            onClick={() => {
              onClickDownload(fileDownloadUrl);
            }}
            id={index}
          >
              ダウンロード
          </Button>

         ))
        }

        {fileDownloadList.length > 1 &&
        fileDownloadList.map((fileDownloadUrl, index) => (
          <p key={index}>
            <Button
              variant="primary"
              className="btn-96 margin-bottom-10"
              onClick={() => {
                onClickDownload(fileDownloadUrl);
              }}
              id={index}
            >
                ダウンロード
            </Button>
          </p>
         ))
        }
      </div>
    );
    // #6555 END
    // #6337 END

    return (
      <Modal
        className="modal-container"
        show={showDialog}
        onHide={this.props.onHandleCloseDialog}
        size={this.props.mdSize}
      >
        <Modal.Header>{noticeInfo.noticeTitle}</Modal.Header>
        <Modal.Body>
          <Form.Group className="form-info">
            <Col xs={12} className="padding-left-clear">
              <p className="margin-10 break-text line-height-20 margin-bottom-5">{noticeInfo.noticeContent}</p>
              <br />
              <div className="margin-bottom-20 text-center">{fileDownloadUrlListView}</div>
              <p className="padding-top-5 padding-left-10">※ダウンロード対象のファイルが存在する場合、ダウンロードボタンが表示されます。</p>
              <p className="padding-top-5 padding-left-10">※件数が多い場合、複数のファイルに分割されます。</p>
              <p className="padding-top-5 padding-left-10">(複数のダウンロードボタンが表示されます。)</p>
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
            <Button
              className="margin-right-10 btn-96"
              variant="primary"
              onClick={this.props.onHandleCloseDialog}
            >
              OK
            </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default EnterpriseDetail;
